<div class="ai-dialog-actions">
    <ng-content></ng-content>
</div>
